export const getProvidersActivityNavigateUrl = () => {
    const filtersFromLS = localStorage.getItem("providersactivity_filters");

    if (filtersFromLS) {
        return `/reports/provider-session-activity?${filtersFromLS}`;
    }
    return `/reports/provider-session-activity`;
};
